export const DIMENSOES_PSICOSSOCIAIS = [
  {
    id: "demandas_trabalho",
    nome: "Demandas de trabalho",
    perguntas: ["1A", "1B", "2A", "2B", "3A", "3B"],
    max: 24,
  },
  {
    id: "organizacao_conteudo",
    nome: "Organização e conteúdo do trabalho",
    perguntas: ["4A", "4B", "5A", "5B", "6A", "6B", "7A", "7B"],
    max: 32,
  },
  {
    id: "relacoes_interpessoais",
    nome: "Relações interpessoais",
    perguntas: ["8A", "8B", "9A", "9B", "10A", "10B", "11A", "11B", "12A", "12B"],
    max: 40,
  },
  {
    id: "interface_trabalho_individuo",
    nome: "Interface trabalho-indivíduo",
    perguntas: ["13", "14A", "14B"],
    max: 9,
  },
  {
    id: "valores_local_trabalho",
    nome: "Valores do local de trabalho",
    perguntas: ["15A", "15B", "16A", "16B"],
    max: 16,
  },
  {
    id: "saude_bem_estar",
    nome: "Saúde e bem-estar",
    perguntas: ["17", "18A", "18B", "19A", "19B"],
    max: 20,
  },
  {
    id: "comportamentos_ofensivos",
    nome: "Comportamentos ofensivos",
    perguntas: ["20", "21", "22", "23"],
    max: 16,
  },
];

export const VERSAO_PONTUACAO_PSICOSSOCIAL = 2;

const CODIGOS_INVERTIDOS_QUATRO = new Set([
  "4A", "4B", "5A", "5B", "6A", "6B", "7A", "7B",
  "8A", "8B", "9A", "9B", "10A", "10B", "11A", "11B",
  "12A", "12B", "15A", "15B", "16A", "16B", "17",
]);

export function getCodigoPergunta(pergunta) {
  return String(pergunta?.codigo || "")
    .trim()
    .toUpperCase();
}

export function normalizarValorPsicossocialLegado(codigo, valor) {
  const c = String(codigo || "").trim().toUpperCase();
  const numero = Number(valor);

  if (!Number.isFinite(numero)) return valor;
  if (CODIGOS_INVERTIDOS_QUATRO.has(c)) return 4 - numero;
  if (c === "13") return 3 - numero;

  return numero;
}

export function normalizarRespostasPsicossociais(
  respostas = {},
  versaoPontuacao = 1
) {
  if (Number(versaoPontuacao || 1) >= VERSAO_PONTUACAO_PSICOSSOCIAL) {
    return respostas;
  }

  return Object.fromEntries(
    Object.entries(respostas).map(([codigo, resposta]) => {
      if (resposta && typeof resposta === "object") {
        const valorAnterior =
          resposta.valorResposta ??
          (Number.isFinite(Number(resposta.probabilidade))
            ? Number(resposta.probabilidade) - 1
            : resposta.valor);
        const valorResposta = normalizarValorPsicossocialLegado(
          codigo,
          valorAnterior
        );
        const probabilidade = Number(valorResposta) + 1;
        const severidade = Number(resposta.severidade || 1);

        return [
          codigo,
          {
            ...resposta,
            valorResposta,
            probabilidade,
            risco: probabilidade * severidade,
          },
        ];
      }

      return [
        codigo,
        normalizarValorPsicossocialLegado(codigo, resposta),
      ];
    })
  );
}

export function opcoesPsicossocial(codigo) {
  const c = String(codigo || "")
    .trim()
    .toUpperCase();

  if (["1B", "12A", "12B"].includes(c)) {
    return [
      { label: "Sempre", valor: 0 },
      { label: "Frequentemente", valor: 1 },
      { label: "Às vezes", valor: 2 },
      { label: "Raramente", valor: 3 },
      { label: "Nunca", valor: 4 },
    ];
  }

  if (
    [
      "1A",
      "2A",
      "2B",
      "3A",
      "3B",
      "18A",
      "18B",
      "19A",
      "19B",
    ].includes(c)
  ) {
    return [
      { label: "Sempre", valor: 4 },
      { label: "Frequentemente", valor: 3 },
      { label: "Às vezes", valor: 2 },
      { label: "Raramente", valor: 1 },
      { label: "Nunca", valor: 0 },
    ];
  }

  if (
    [
      "4A",
      "4B",
      "5A",
      "5B",
      "6A",
      "6B",
      "7A",
      "7B",
      "8A",
      "8B",
      "9A",
      "9B",
      "10A",
      "10B",
      "11A",
      "11B",
      "15A",
      "15B",
      "16A",
      "16B",
    ].includes(c)
  ) {
    return [
      { label: "Em grande parte", valor: 0 },
      { label: "Em boa parte", valor: 1 },
      { label: "De certa forma", valor: 2 },
      { label: "Pouco", valor: 3 },
      { label: "Muito pouco", valor: 4 },
    ];
  }

  if (c === "13") {
    return [
      { label: "Muito satisfeito", valor: 0 },
      { label: "Satisfeito", valor: 1 },
      { label: "Insatisfeito", valor: 2 },
      { label: "Muito insatisfeito", valor: 3 },
    ];
  }

  if (["14A", "14B"].includes(c)) {
    return [
      { label: "Sim, com certeza", valor: 3 },
      { label: "Sim, até certo ponto", valor: 2 },
      { label: "Sim, mas muito pouco", valor: 1 },
      { label: "Não, realmente não", valor: 0 },
    ];
  }

  if (c === "17") {
    return [
      { label: "Excelente", valor: 0 },
      { label: "Muito boa", valor: 1 },
      { label: "Boa", valor: 2 },
      { label: "Razoável", valor: 3 },
      { label: "Ruim", valor: 4 },
    ];
  }

  if (["20", "21", "22", "23", "24", "25", "26"].includes(c)) {
    return [
      { label: "Sim, diariamente", valor: 4 },
      { label: "Sim, semanalmente", valor: 3 },
      { label: "Sim, mensalmente", valor: 2 },
      { label: "Sim, poucas vezes", valor: 1 },
      { label: "Não", valor: 0 },
    ];
  }

  return [];
}

export function getOpcoesPsicossocial(pergunta) {
  const opcoesPadronizadas = opcoesPsicossocial(getCodigoPergunta(pergunta));

  if (opcoesPadronizadas.length > 0) {
    return opcoesPadronizadas;
  }

  if (Array.isArray(pergunta?.opcoes) && pergunta.opcoes.length > 0) {
    return pergunta.opcoes;
  }

  return [];
}

export function getValorResposta(valor) {
  if (valor == null || valor === "") return 0;

  if (typeof valor === "number") return valor;

  if (typeof valor === "object" && valor.valor != null) {
    return Number(valor.valor || 0);
  }

  if (typeof valor === "object" && valor.valorResposta != null) {
    return Number(valor.valorResposta || 0);
  }

  const numero = Number(valor);

  return Number.isFinite(numero) ? numero : 0;
}

export function calcularDimensoesPsicossociais(respostas = {}) {
  return DIMENSOES_PSICOSSOCIAIS.map((dim) => {
    const total = dim.perguntas.reduce(
      (soma, codigo) =>
        soma + getValorResposta(respostas[codigo]),
      0
    );

    const percentual =
      dim.max > 0
        ? Number(((total / dim.max) * 5).toFixed(1))
        : 0;

    return {
      ...dim,
      total,
      percentual,
    };
  });
}

// ======================================================
// MATRIZ DE RISCO 5x5
// ======================================================

export const MATRIZ_RISCO_5X5 = {
  MUITO_BAIXO: {
    nivel: "muito_baixo",
    label: "Risco Muito Baixo",
    cor: "#00cc66",
    faixa: "1 a 4",
    classificacao: "Aceitavel",
    acao: "Manter controles e monitoramento periodico",
  },

  BAIXO: {
    nivel: "baixo",
    label: "Risco Baixo",
    cor: "#8bc34a",
    faixa: "5 a 9",
    classificacao: "Toleravel",
    acao: "Monitoramento rotineiro",
  },

  MEDIO: {
    nivel: "medio",
    label: "Risco Médio",
    cor: "#ffff00",
    faixa: "10 a 14",
    classificacao: "Moderado",
    acao: "Planejar ações de controle",
  },

  ALTO: {
    nivel: "alto",
    label: "Risco Alto",
    cor: "#ff9900",
    faixa: "15 a 19",
    classificacao: "Nao Aceitavel",
    acao: "Exige plano de ação imediato",
  },

  CRITICO: {
    nivel: "critico",
    label: "Risco Crítico",
    cor: "#ff0000",
    faixa: "20 a 25",
    classificacao: "Intoleravel",
    acao: "Exige interrupção imediata ou mitigação emergencial",
  },
};

export function calcularRiscoMatriz(probabilidade, severidade) {
  const p = Number(probabilidade || 0);
  const s = Number(severidade || 0);

  return p * s;
}

export function classificarRiscoMatriz(valor) {
  const risco = Number(valor || 0);

  if (risco >= 20) {
    return MATRIZ_RISCO_5X5.CRITICO;
  }

  if (risco >= 15) {
    return MATRIZ_RISCO_5X5.ALTO;
  }

  if (risco >= 10) {
    return MATRIZ_RISCO_5X5.MEDIO;
  }

  if (risco >= 5) {
    return MATRIZ_RISCO_5X5.BAIXO;
  }

  return MATRIZ_RISCO_5X5.MUITO_BAIXO;
}

export function calcularMediaRiscosPsicossociais(respostas = {}) {
  const riscos = Object.values(respostas)
    .map((item) => {
      if (!item || typeof item !== "object") return null;

      const probabilidade = Number(item.probabilidade || 0);
      const severidade = Number(item.severidade || 0);
      const risco = Number(item.risco || probabilidade * severidade);

      return Number.isFinite(risco) && risco > 0 ? risco : null;
    })
    .filter((risco) => risco != null);

  return riscos.length
    ? Number(
        (
          riscos.reduce((soma, risco) => soma + risco, 0) / riscos.length
        ).toFixed(1)
      )
    : 0;
}

export function obterCorMatriz(probabilidade, severidade) {
  const valor = calcularRiscoMatriz(
    probabilidade,
    severidade
  );

  return classificarRiscoMatriz(valor).cor;
}

export function obterTextoRisco(probabilidade, severidade) {
  const valor = calcularRiscoMatriz(
    probabilidade,
    severidade
  );

  const classificacao =
    classificarRiscoMatriz(valor);

  return {
    valor,
    ...classificacao,
  };
}

// ======================================================
// IDADE
// ======================================================

export function calcularIdade(dataNascimento) {
  if (!dataNascimento) return null;

  const nascimento = new Date(
    `${dataNascimento}T00:00:00`
  );

  if (Number.isNaN(nascimento.getTime())) {
    return null;
  }

  const hoje = new Date();

  let idade =
    hoje.getFullYear() -
    nascimento.getFullYear();

  const aniversarioPassou =
    hoje.getMonth() > nascimento.getMonth() ||
    (hoje.getMonth() === nascimento.getMonth() &&
      hoje.getDate() >= nascimento.getDate());

  if (!aniversarioPassou) {
    idade -= 1;
  }

  return idade >= 0 ? idade : null;
}

export function classificarFaixaEtaria(
  dataNascimento
) {
  const idade = calcularIdade(dataNascimento);

  if (idade == null) {
    return "Não informado";
  }

  if (idade <= 24) {
    return "Até 24 anos";
  }

  if (idade <= 34) {
    return "25 a 34 anos";
  }

  if (idade <= 44) {
    return "35 a 44 anos";
  }

  if (idade <= 54) {
    return "45 a 54 anos";
  }

  return "55 anos ou mais";
}
